/* eslint-disable no-unused-vars */
export enum FacilityKey {
  CQ = 'CQ',
  FES = 'FES',
  OC = 'OC',
  KINEX = 'KINEX',
  SV = 'SV',
  ZOOM = 'ZOOM',
}
